import React from 'react'
import './ui.css'

const VARIANT_CLASS = {
  default: 'default',
  success: 'green',
  warning: 'amber',
  blue: 'blue',
  green: 'green',
  amber: 'amber',
  purple: 'purple',
  grey: 'grey'
}

/**
 * Бейдж-тег. default — класс ui-tag-badge-default (визуал как blue); success→green, warning→amber; blue, purple, grey.
 */
function TagBadge ({ children, variant = 'default', className = '' }) {
  const c =
    VARIANT_CLASS[variant] != null ? VARIANT_CLASS[variant] : VARIANT_CLASS.default
  return (
    <span
      className={`ui-tag-badge ui-tag-badge-${c}${className ? ` ${className}` : ''}`}
    >
      {children}
    </span>
  )
}

export default TagBadge
